/**
 * Author: Wilson Pilco Nuñez
 * Email: wilsonaux1@gmail.com
 * Created at: 2024-09-27 16:25
 */

import { DentalClinicService } from "./service.js";

export default DentalClinicService;
